import { memo } from 'react';

import { DefaultNoWorkspaceContentState } from '~/components/AllContent/DefaultNoWorkspaceContentState';
import { useCanShowBoardsInAllContent } from '~/components/AllContent/hooks/useCanShowBoardsInAllContent';
import { PrivateTableView, type PrivateTableViewProps } from '~/components/TableView/PrivateTableView';
import { PrivateAssetTableRow } from '~/components/TableView/PrivateTableView/PrivateAssetTableRow';
import { PrivateBoardTableRow } from '~/components/TableView/PrivateTableView/PrivateBoardTableRow';

export type AllContentTableViewProps = {
  scrollElementRef: PrivateTableViewProps['scrollElementRef'];
};

/**
 * @deprecated Use SearchPageTableView instead
 */
export const AllContentTableView = memo(({ scrollElementRef }: AllContentTableViewProps) => {
  const { canShowBoards } = useCanShowBoardsInAllContent();

  return (
    <PrivateTableView
      EmptyState={DefaultNoWorkspaceContentState}
      scrollElementRef={scrollElementRef}
      renderBoardRow={({ data, key, rowStyle }) => <PrivateBoardTableRow key={key} data={data} style={rowStyle} />}
      renderAssetRow={({ data, key, rowStyle }) => <PrivateAssetTableRow key={key} data={data} style={rowStyle} />}
      showBoards={canShowBoards}
    />
  );
});

AllContentTableView.displayName = 'AllContentTableView';
